import formatNumber from './formatNumber';

export interface FormatBytesOptions { locale: string; decimals?: number }

// https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
/**
 * @component
 * @visibleName formatBytes
 */
export default function formatBytes(bytes: number, { locale, decimals = 2 }: FormatBytesOptions) {
  if (bytes === 0) return '0 Byte';

  if (bytes <= 1 && bytes >= -1) {
    return `${bytes} Byte`;
  }

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const factor = (10 ** decimals);
  const roundedNumber = Math.round((bytes / k ** i) * factor) / factor;
  const formattedNumber = formatNumber(roundedNumber, { locale });

  return `${formattedNumber} ${sizes[i]}`;
}
